import { PreventSpaceDirective } from './prevent-space/prevent-space.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BixTooltipDirective } from './bix-tooltip/bix-tooltip.directive';
import { BixPopoverDirective } from './bix-popover/bix-popover.directive';
import { BixPopperCloseDirective } from './bix-popover/bix-popper-close.directive';
import { FixedHeaderDirective } from './fixed-header/fixed-header.directive';
import { ThousandSeperatorDirective } from './thousand-seperator/thousand-seperator.directive';
import { OnlyNumberDirective } from './only-number/only-number.directive';
import { AutoresizeDirective } from './autoresize/autoresize.directive';


@NgModule({
  declarations: [BixTooltipDirective, BixPopoverDirective, BixPopperCloseDirective, FixedHeaderDirective, ThousandSeperatorDirective, OnlyNumberDirective, PreventSpaceDirective, AutoresizeDirective],
  imports: [
    CommonModule
  ],
  exports: [
    BixTooltipDirective,
    BixPopoverDirective,
    BixPopperCloseDirective, 
    FixedHeaderDirective, 
    ThousandSeperatorDirective,
    OnlyNumberDirective,
    PreventSpaceDirective,
    AutoresizeDirective
  ]
})
export class DirectivesModule { }
